// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-table-tbody .ant-table-row td[data-v-ef2bb396]{padding-top:10px;padding-bottom:10px}", ""]);
// Exports
module.exports = exports;
